export const declarationOfEmploymentStatus = (name?: string, date?: string) => {
  return [
    { text: 'Declaration Of Employment Status', style: 'h1' },
    { text: 'This refers to any gaps in employment history', style: 'subheader'},
    { text: 'I understand that I must provide my complete employment history for the past 3 years, and all CDL required employment for 7 years preceding that. Any gaps in employment longer that 1 month are explained as follows:', style: 'p'},

    { canvas: [
        // From
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        // To
        {
          type: 'line',
          x1: 170,
          y1: 0,
          x2: 320,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },
    { text: "From", style: 'label', margin: [0,-2,0,0]},
    { text: "To", style: 'label', margin: [170,-12,0,0]},

    { text: 'During this time, I was engaged, in the following activity:', margin: [0, 20, 0, 0] },
    { canvas: [
        // Line 1
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 500,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        // Line 2
        {
          type: 'line',
          x1: 0,
          y1: 20,
          x2: 500,
          y2: 20,
          lineWidth: 1,
          lineColor: 'black',
        },
        // Line 3
        {
          type: 'line',
          x1: 0,
          y1: 40,
          x2: 500,
          y2: 40,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },


    { text: "In addition:", margin: [0, 20, 0, 0]},
    { text: '__________ I was not employed by any company or individual'},
    { text: '__________ I was not convicted of any criminal act involving the use of a commercial motor vehicle or while driving a commercial motor vehicle'},

    { table: {
        body: [
          [{ text: 'To Be Read and Signed By Applicant', alignment: 'center', fontSize: 12, bold: true, margin: [0, 10, 0, 10], border: [true, true, true, false] }],
          [{ text: 'I authorize you to make such investigations and inquiries of my personal, employment, financial or medical history and other related matters as may be necessary in arriving at an employment decision. (Generally inquiries regarding medical history will be made only if and after a conditional offer of employment has been extended.) I hereby release employers, schools, health care providers and other persons from all liability in responding to inquiries and releasing information in connection with my application.', fontSize: 10, margin: [10, 0, 10, 0], alignment: 'justify', border: [true, false, true, false] }],
          [{ text: 'In the event of employment, I understand that false or misleading information given in my application or interviews may result in discharge. I understand, also, that I am required to abide by all rules and regulations of the Company.', fontSize: 10, margin: [10, 0, 10, 0], alignment: 'justify', border: [true, false, true, false] }],
          [{ text: 'I understand that information I provide regarding current and/or previous employers may be used, and these employers will be contacted, for the purpose of investigating my safety performance history as required by 49 CFR 391.23 (b) and (e). I understand that I have the right to:', fontSize: 10, margin: [10, 0, 10, 0], alignment: 'justify', border: [true, false, true, false] }],
          [{ ul:
              [
                'Review information provided by the previous employers:',
                'Have errors in the information corrected by previous employers and for those employers to resent the correct information to the prospective employer.',
                'Have a rebuttal attached to the alleged erroneous information, if the previous employer(s) and I cannot agree on the accuracy of the information.',
              ],
            fontSize: 10,
            margin: [20,10,20,10],
            border: [true, false, true, false],
          }],
          [{
            canvas: [
              // Name line
              {
                type: 'line',
                x1: 10,   // Start of the line
                y1: 0,   // Top of the page
                x2: 150, // Length of the line
                y2: 0,   // Same horizontal level
                lineWidth: 1,
                lineColor: 'black',
              },
              // Signature line with a 20px gap after the name line
              {
                type: 'line',
                x1: 170,   // Start of the line (previous line end + 20px gap)
                y1: 0,     // Same vertical position
                x2: 320,   // Length of the line
                y2: 0,     // Same horizontal level
                lineWidth: 1,
                lineColor: 'black',
              },
              // Date line with a 20px gap after the signature line
              {
                type: 'line',
                x1: 340,   // Start of the line (previous line end + 20px gap)
                y1: 0,     // Same vertical position
                x2: 490,   // Length of the line
                y2: 0,     // Same horizontal level
                lineWidth: 1,
                lineColor: 'black',
              },
            ],
            style: 'input',
            border: [true, false, true, false],
          }],
          [{ text: `${name}`, margin: [10,-24, 0, 0], border: [true, false, true, false] }],
          [{ text: "Driver's Name", style: 'label', margin: [10,-14,0,0], border: [true, false, true, false]}],
          [{ text: "Driver's Signature", style: 'label', margin: [170,-18,0,0], border: [true, false, true, false]}],
          [{ text: `${date}`, margin: [340,-40, 0, 0], border: [true, false, true, false]}],
          [{ text: "Date", style: 'label', margin: [340,-28,0,0], border: [true, false, true, true] }],
        ],
      },
      margin: [0, 20, 0, 0],
    },

    { text: '', pageBreak: 'before' },
  ];
};